import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Form, ButtonGroup} from "react-bootstrap";
import { getCategories, getUsers, getDepartments, getTemplates, getDesignatedDepartments } from "../../utils/api";
import TemplatesTable from "./TemplatesTable";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { SetSelectedDepartment, GetSelected, SetSelectedCategory } from "../../utils/DesignatedDepartments";
import { ColoredLine } from "../elements/ColoredLine";
import { checkUserToken } from "../../utils/checkUser";
const animatedComponents = makeAnimated();
const Templates = () => {
  // const [openNewModal, setOpenNewModal] = useState(false);
  //  const [sectionCreated, setSectionCreated] = useState(false);
  //  const [sectionError, setSectionError] = useState(false);

  const [templates, setTemplates] = useState([]);
  const [templatesVisible, setTemplatesVisible] = useState([]);
  const [searchText, setSearchText] = useState("");

  const [categories, setCategories] = useState([]);
  const [users, setUsers] = useState([]);

  const [designatedDepartments, setDesignatedDepartments] = useState([]);
  const [chosenCategory, setChosenCategory] = useState("All")
  const [chosenDepartment, setChosenDepartment] = useState("")

  const {selected} = GetSelected();



  useEffect(() => {
    getDesignatedDepartments(setDesignatedDepartments);
    getUsers(setUsers);
    checkUserToken();
  }, []);

  useEffect(() => {
    if ( chosenDepartment !== "" && chosenDepartment !== undefined) {
      getTemplates(setTemplates, chosenDepartment, chosenCategory);
      getCategories(setCategories, chosenDepartment);
    }
    setChosenCategory("All")
  }, [chosenDepartment])

  /* Gets the selected department */
  useEffect(() => {
    if (selected.department === "" && designatedDepartments[0] !== undefined) {
      setChosenDepartment(designatedDepartments[0].value);
    } else {
      setChosenDepartment(selected.department);
    }
    setChosenCategory(selected.category);
  },[designatedDepartments])
  
  useEffect(() => {
    if ( chosenDepartment !== "" && chosenDepartment !== undefined) {
      getTemplates(setTemplates, chosenDepartment, chosenCategory);
    }
  }, [chosenCategory])
/***********************/
/* Method for filtering sections */

//Filter Level 2
useEffect(() => {
    setTemplatesVisible(
      templates.filter((template) => {
        return (
          template.name.toLowerCase().includes(searchText.toLowerCase()) ||
          template.description.toLowerCase().includes(searchText.toLowerCase()) ||
          template._id.toLowerCase().includes(searchText.toLowerCase())  
        );
      })
    ); 
  }, [searchText, templates]);

  
  //   {sectionCreated && <AlertComponent type="success" text="Section Created!"/>}
  // {openNewModal && <SectionModel openNewModal={openNewModal} setOpenNewModal={setOpenNewModal} setSectionCreated={setSectionCreated} setSectionError={setSectionError} getSections={getSections} />}
  // <Col>    <Button className="pull-right" className="primary-button border-button" onClick={() => setOpenNewModal(true)}>+ New Section</Button>             </Col>

  return (
    <Container fluid className="template-container">
      <Row className="row-header">
          <h2 className="page-header">Templates</h2>
      </Row>
      <ColoredLine color="#DEDEDE" />

     <Row className="row-level-1">
     <h5 className="filter-headers">Department</h5>
      <Col sm={7} xs={8}>
          <div className="reactSelect" >
            <Select
                closeMenuOnSelect={true}
                components={animatedComponents}
                value={{label: chosenDepartment}}
                options={designatedDepartments}
                onChange={(e) => {setChosenDepartment(e.value); SetSelectedDepartment(e.value)}}
            />
          </div>  
      </Col>
      </Row>

      <Row className="row-level-2">
        <h5 className="filter-headers">Category</h5>
          <Col>
            <ButtonGroup>
                <Button onClick={() => {setChosenCategory("All"); SetSelectedCategory("All")}} className={chosenCategory === "All" && "xl-button"} variant={chosenCategory === "All" ? "secondary" : "outline-secondary"}>All</Button>
                {categories.map(category => {
                    if (category.title === chosenCategory){
                        return <Button onClick={() => {setChosenCategory(category.title); SetSelectedCategory(category.title)}} className="xl-button" variant="secondary" >{category.title}</Button>
                    } else {
                        return <Button onClick={() => {setChosenCategory(category.title); SetSelectedCategory(category.title)}}variant="outline-secondary" >{category.title}</Button>
                    }             
                })}
              </ButtonGroup>
           </Col>
      </Row>

      <Row>
      <h5 className="filter-headers">Search</h5>
        <Col sm={8} xs={9}>
          <Form.Control
            onChange={(e) => setSearchText(e.target.value)}
            className="mb-3"
            type="text"
            placeholder="Search name or description..."
          />
        </Col>
      </Row>
      <TemplatesTable templates={templatesVisible} users={users} chosenDepartment={chosenDepartment} />
    </Container>
  );
};

export default Templates;
